import { render, staticRenderFns } from "./CodeCommentLoadingIndicator.vue?vue&type=template&id=8ac6d934&scoped=true"
import script from "./CodeCommentLoadingIndicator.vue?vue&type=script&lang=js"
export * from "./CodeCommentLoadingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac6d934",
  null
  
)

export default component.exports